import { CustomError } from './CustomError';
import { ErrorCodes } from '../literals';

export class NotModifiedError extends CustomError {
  constructor(message = 'Not modified') {
    super(message, ErrorCodes.notModified);
  }
}
